import type { UseFormReturn } from "react-hook-form";
import { ArrowRight, KeyRound, Lock, Mail } from "lucide-react";
import type { LoginRequest } from "@opus-dt/shared-types";
import { ThemeToggle } from "@/components/ThemeToggle";

interface LoginPanelProps {
  form: UseFormReturn<LoginRequest>;
  onSubmit: (values: LoginRequest) => void | Promise<void>;
  isPending: boolean;
  needsTotp: boolean;
}

// Coluna direita: marca + formulário (fiel ao import) + toggle de tema global.
export function LoginPanel({ form, onSubmit, isPending, needsTotp }: LoginPanelProps) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = form;
  return (
    <div className="login-panel">
      <div className="login-panel-top">
        <ThemeToggle />
      </div>
      <div className="login-brand">
        <img src="/logo-full.png" alt="Opus DT — Digital Twin" />
      </div>
      <h1 className="login-title">Entrar na plataforma</h1>
      <p className="login-lead">Acesse seu gêmeo digital operacional.</p>
      <form className="login-form" onSubmit={(e) => void handleSubmit(onSubmit)(e)} noValidate>
        <div className="login-field">
          <label htmlFor="email">E-mail</label>
          <div className="login-inp">
            <Mail className="login-ic" aria-hidden="true" />
            <input
              id="email"
              type="email"
              autoComplete="email"
              placeholder="voce@empresa.com.br"
              aria-invalid={!!errors.email}
              {...register("email")}
            />
          </div>
          {errors.email ? (
            <p className="login-err" role="alert">
              {errors.email.message}
            </p>
          ) : null}
        </div>
        <div className="login-field">
          <label htmlFor="password">Senha</label>
          <div className="login-inp">
            <Lock className="login-ic" aria-hidden="true" />
            <input
              id="password"
              type="password"
              autoComplete="current-password"
              placeholder="••••••••"
              aria-invalid={!!errors.password}
              {...register("password")}
            />
          </div>
          {errors.password ? (
            <p className="login-err" role="alert">
              {errors.password.message}
            </p>
          ) : null}
        </div>
        {needsTotp ? (
          <div className="login-field">
            <label htmlFor="totpCode">Código TOTP</label>
            <div className="login-inp">
              <KeyRound className="login-ic" aria-hidden="true" />
              <input
                id="totpCode"
                inputMode="numeric"
                maxLength={6}
                autoComplete="one-time-code"
                aria-invalid={!!errors.totpCode}
                {...register("totpCode")}
              />
            </div>
            {errors.totpCode ? (
              <p className="login-err" role="alert">
                {errors.totpCode.message}
              </p>
            ) : null}
          </div>
        ) : null}
        <div className="login-row">
          <label className="login-check">
            <input type="checkbox" {...register("keepLoggedIn")} />
            <span>Manter conectado</span>
          </label>
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid -- placeholder visível do fluxo de
              reset de senha (ainda sem rota); vira <a href> real quando o reset existir */}
          <a href="#" className="login-forgot" onClick={(e) => e.preventDefault()}>
            Esqueci minha senha
          </a>
        </div>
        <button className="login-submit" type="submit" disabled={isPending}>
          {isPending ? "Entrando…" : "Entrar"}
          <ArrowRight aria-hidden="true" />
        </button>
        <p className="login-foot">© 2026 Opus DT · Digital Twin</p>
      </form>
    </div>
  );
}
